import queryString from "query-string"
import { IPaginationReq } from "utils/interfaces"
import { TAGS, api } from "../../api"
import {
  IBuyGenesisPreformResponse,
  IGenesisPreformLeadersResponse,
  IGenesisPreformStore,
  IPreformInstanceResponse,
  IUnpackPreformResponse
} from "./types"

export const preformApi = api.enhanceEndpoints({ addTagTypes: [TAGS.PREFORMS] })

export const preformsEndpoints = preformApi.injectEndpoints({
  endpoints: (builder) => ({
    getGenesisPreformStore: builder.query<IGenesisPreformStore, void>({
      query: () => ({
        url: "/preforms/genesis-preforms-store",
        method: "GET"
      }),
      providesTags: [{ type: TAGS.PREFORMS, id: "GENESIS_PREFORM_STORE" }]
    }),
    getPreformsInventory: builder.query<
      IPreformInstanceResponse,
      IPaginationReq & Record<any, any>
    >({
      query: ({ page, limit, ...filters }) => ({
        url: `/preforms/preforms-instances?${queryString.stringify({ page, limit, ...filters }, { skipNull: false, skipEmptyString: true })}`,
        method: "GET"
      }),
      providesTags: (
        result,
        _,
        params
      ): readonly { type: typeof TAGS.PREFORMS; id: string }[] =>
        result
          ? [
              {
                type: TAGS.PREFORMS as const,
                id: `preforms-list:page:${params.page}:limit:${params.limit}`
              },
              { type: TAGS.PREFORMS as const, id: "PREFORM_INSTANCE" }
            ]
          : [{ type: TAGS.PREFORMS as const, id: "PREFORM_INSTANCE" }]
    }),
    getBoughtGenesisPreformsLeaders: builder.query<
      IGenesisPreformLeadersResponse,
      void
    >({
      query: () => ({
        url: `/preforms/bought-preforms-leaders`,
        method: "GET"
      }),
      providesTags: (
        result
      ): readonly { type: typeof TAGS.PREFORMS; id: string }[] =>
        result
          ? [
              {
                type: TAGS.PREFORMS as const,
                id: `GENESIS_PREFORM_LEADERS:my-position:${result?.meInLeaders.position}`
              }
            ]
          : [{ type: TAGS.PREFORMS as const, id: "GENESIS_PREFORM_LEADERS" }]
    }),
    buyGenesisPreform: builder.mutation<
      IBuyGenesisPreformResponse,
      { count: number }
    >({
      query: ({ count }) => ({
        url: `/preforms/buy-genesis-preform`,
        method: "PATCH",
        data: { count }
      })
    }),
    unpackPreform: builder.mutation<IUnpackPreformResponse, string>({
      query: (id: string) => ({
        url: `/preforms/unpack/${id}`,
        method: "PATCH"
      })
    })
  })
})
